import { lightenColor } from "@/utils/lightenColor";
import React from "react";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

interface ProfileIconAttributes {
  className?: string;
  brandingColor?: string;
}

export const ProfileIcon: React.FC<ProfileIconAttributes> = ({
  className = "",
  brandingColor = "#22880",
}: ProfileIconAttributes) => {
  const lighterBrandingColor = lightenColor(brandingColor, 90);
  return (
    <svg
      data-testid={applyDataTestId(pom.icons.profileIcon)}
      className={className}
      width="68"
      height="56"
      viewBox="0 0 68 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56 8H4C1.79086 8 0 9.79086 0 12V52C0 54.2091 1.79086 56 4 56H12C12 53.7909 13.7909 52 16 52C18.2091 52 20 53.7909 20 56H40C40 53.7909 41.7909 52 44 52C46.2091 52 48 53.7909 48 56H56C58.2091 56 60 54.2091 60 52V12C60 9.79086 58.2091 8 56 8Z"
        fill={`${lighterBrandingColor}`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62 2H10C7.79086 2 6 3.79086 6 6V46C6 48.2091 7.79086 50 10 50H18C18 47.7909 19.7909 46 22 46C24.2091 46 26 47.7909 26 50H46C46 47.7909 47.7909 46 50 46C52.2091 46 54 47.7909 54 50H62C64.2091 50 66 48.2091 66 46V6C66 3.79086 64.2091 2 62 2Z"
        fill="white"
        stroke="#5C5C5C"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 24C29.866 24 33 20.866 33 17C33 13.134 29.866 10 26 10C22.134 10 19 13.134 19 17C19 20.866 22.134 24 26 24Z"
        stroke="#5C5C5C"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 38C14 31.3726 19.3726 26 26 26C32.6274 26 38 31.3726 38 38"
        stroke="#5C5C5C"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42 18H54"
        stroke={brandingColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42 26H58"
        stroke={brandingColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
